import React, { useState, useEffect } from "react";
import BodyPassword from "../account/BodyPassword";
import Layout from "../Layout";
import HeaderAccount from "../account/HeaderAccount";
import useUserStore from "../../utils/storeApp";

const ChangePasswordMain = () => {
  const { isUserLogedIn, userRole, userToken } = useUserStore((state) => ({
    isUserLogedIn: state.isUserLogedIn,
    userRole: state.userRole,
    userToken: state.userToken,
  }));

  return (
    <Layout>
      {userRole === "SES ADMINISTRATOR" || userRole === "ADMINISTRATOR" ? (
        <HeaderAccount />
      ) : null}
      <section className="layout-container">
        <div className="container">
          <div className="descript-container">
            <div className="form-title g-clr">Change Password</div>
           Enter your current password if it hasn't been entered already, then update your password to meet all the required criteria.
          </div>
          <BodyPassword />
        </div>
      </section>
    </Layout>
  );
};


export default ChangePasswordMain;
